import { combineReducers } from 'redux';

// import filterBarOpts from './filter-bar-opts';
import quickLinks from './quick-links';

const rootReducer = combineReducers({
  // filterBarOpts,
  quickLinks
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/modules/dashboard/reducers/ui/index.js